import { render } from "./detail-sent-messages-table.component.vue?vue&type=template&id=211eaf03&scoped=true"
import script from "./detail-sent-messages-table.component.vue?vue&type=script&lang=js"
export * from "./detail-sent-messages-table.component.vue?vue&type=script&lang=js"

import "./detail-sent-messages-table.component.vue?vue&type=style&index=0&id=211eaf03&scoped=true&lang=css"

import exportComponent from "/mnt/ssd2/projects/techno2_remaster/client_ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-211eaf03"]])

export default __exports__